"use client";

import type React from "react";

import { cn } from "@/lib/utils";

import { HamburgerButton } from "./HamburgerButton";
import { Navbar } from "./Navbar";

interface PageHeaderProps {
  title?: string;
  rightSlot?: React.ReactNode;
  leftSlot?: React.ReactNode;
  showMobileTitle?: boolean;
}

export function PageHeader({ title, rightSlot, leftSlot, showMobileTitle }: PageHeaderProps) {
  return (
    <>
      {/* Mobile: sticky nav bar */}
      <div className="sticky top-0 z-50 md:hidden">
        <Navbar
          leftSlot={
            <>
              <HamburgerButton />
              {leftSlot}
            </>
          }
          centerSlot={showMobileTitle ? title : null}
          rightSlot={rightSlot}
          showLogo={false}
        />
      </div>

      {/* Desktop: content header */}
      {(title || leftSlot) && (
        <header
          className={cn(
            "flex items-center justify-between gap-3 mx-auto w-full max-w-lg px-3 pt-4 md:px-4 md:pt-8",
            (showMobileTitle || leftSlot) && "hidden md:flex"
          )}
        >
          {title ? (
            <h1 className="text-2xl font-semibold tracking-tight md:text-3xl">{title}</h1>
          ) : (
            leftSlot
          )}
          {rightSlot && <div className="hidden md:flex items-center gap-4">{rightSlot}</div>}
        </header>
      )}
    </>
  );
}
